export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center pt-16">
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20flat%20lay%20composition%20of%20contemporary%20fashion%20accessories%20lifestyle%20products%20and%20fabric%20textures%20on%20warm%20sand%20colored%20backdrop%2C%20soft%20diffused%20natural%20morning%20lighting%20from%20large%20arched%20window%2C%20elegant%20editorial%20composition%20with%20designer%20sneakers%20premium%20handbag%20and%20organic%20textile%20draping%2C%20warm%20neutral%20earthy%20tones%20with%20subtle%20terracotta%20and%20cream%20accents%2C%20no%20text%20or%20logos%20visible%2C%20clean%20sophisticated%20aesthetic%20with%20painterly%20quality%2C%20high%20detail%20on%20material%20textures%20and%20soft%20shadows&width=1440&height=1000&seq=hero-bg-main-v2&orientation=landscape"
          alt="Itaobuy spreadsheet system lifestyle photography with fashion products and accessories on warm sand backdrop"
          title="Itaobuy Spreadsheet System – Product Sourcing Lifestyle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              Itaobuy Sheet
              <br />
              <span className="text-white/90">Smart Sourcing System</span>
            </h1>
            <p className="mt-5 text-white/75 text-base md:text-lg max-w-lg mx-auto lg:mx-0 leading-relaxed">
              Discover how thousands of buyers use the <strong>Itaobuy Spreadsheet system</strong> to source products from China with better price transparency, faster processing, and safer cross-border shopping.
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                ITAOBUY SHEET
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border border-white/30 text-white text-sm font-semibold hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                BUY IT NOW
                <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
            <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start text-white/60 text-xs">
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-primary-400"></i>
                Transparent Pricing
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-primary-400"></i>
                Verified Product Data
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-primary-400"></i>
                Global Shipping Support
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-check-line w-3.5 h-3.5 flex items-center justify-center text-primary-400"></i>
                Beginner Friendly System
              </span>
            </div>
          </div>

          <div className="flex-1 hidden lg:block">
            <div className="grid grid-cols-3 gap-4">
              <div className="col-span-2">
                <div className="rounded-2xl overflow-hidden bg-background-50/10 backdrop-blur-sm">
                  <img
                    src="https://readdy.ai/api/search-image?query=Fresh%20white%20designer%20sneakers%20with%20subtle%20beige%20accents%20displayed%20on%20a%20warm%20limestone%20pedestal%2C%20soft%20natural%20diffused%20daylight%2C%20clean%20premium%20product%20photography%2C%20minimal%20elegant%20composition%2C%20warm%20neutral%20background%20with%20subtle%20texture%2C%20editorial%20fashion%20aesthetic%2C%20soft%20diffused%20shadows%20highlighting%20premium%20materials%20and%20craftsmanship%2C%20no%20text%20or%20branding%20visible&width=500&height=600&seq=hero-main-prod-v2&orientation=portrait"
                    alt="Itaobuy spreadsheet featured product - modern designer sneakers"
                    title="Itaobuy Spreadsheet Featured Product"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="flex flex-col gap-4">
                <div className="rounded-xl overflow-hidden bg-background-50/10 backdrop-blur-sm aspect-square">
                  <img
                    src="https://readdy.ai/api/search-image?query=Elegant%20structured%20leather%20satchel%20bag%20in%20warm%20caramel%20tone%20on%20natural%20linen%20surface%2C%20soft%20natural%20diffused%20daylight%2C%20clean%20premium%20product%20photography%2C%20warm%20neutral%20backdrop%20with%20subtle%20texture%2C%20editorial%20fashion%20aesthetic%2C%20soft%20shadows%20highlighting%20fine%20leather%20grain%20and%20gold%20toned%20hardware%2C%20no%20text%20or%20branding%20visible&width=300&height=300&seq=hero-thumb-bags-v2&orientation=squarish"
                    alt="Itaobuy spreadsheet - Bags category"
                    title="Itaobuy Spreadsheet Bags Category"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden bg-background-50/10 backdrop-blur-sm aspect-square">
                  <img
                    src="https://readdy.ai/api/search-image?query=Casual%20lightweight%20linen%20shirt%20in%20warm%20sand%20color%20folded%20on%20natural%20linen%20surface%2C%20soft%20natural%20diffused%20daylight%2C%20clean%20premium%20product%20photography%2C%20warm%20neutral%20background%20with%20subtle%20texture%2C%20editorial%20fashion%20aesthetic%2C%20soft%20shadows%20highlighting%20fabric%20weave%20texture%2C%20no%20text%20or%20branding%20visible&width=300&height=300&seq=hero-thumb-apparel-v2&orientation=squarish"
                    alt="Itaobuy spreadsheet - Apparel category"
                    title="Itaobuy Spreadsheet Apparel Category"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}